import { useMutation } from '@tanstack/react-query';

import Client from './client';

import type { UseMutationOptions } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

export const useLicensePlateCreate = (
  options: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof Client.createLicensePlate>>,
      AxiosResponse,
      Parameters<typeof Client.createLicensePlate>[0],
      unknown
    >,
    'mutationFn'
  > = {},
) => {
  const mutate = useMutation({
    ...options,
    mutationFn: Client.createLicensePlate,
  });

  return mutate;
};
